import React from "react";
import Model from "../../Model";
import tw from "tailwind-styled-components";
import { DeleteBtn, SideCancelBtn, SubmitBtn } from "../../Styles/InputStyles";


const UnlinkCharges = ({
    setShowLinkUnlinkModel,
    selectedData,
    linkPropertyLoading,
    linkPropertyMutate,
    propId
}) => {
    const handleDeleteSubmit = () => {
        linkPropertyMutate({
            propId: propId,
            extraChargeId: selectedData?.id,
            toggleValue: 0
        });
    };

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setShowLinkUnlinkModel}
            title="Confirm Unlink Charge"
        >
            <WarningText>
                Are you sure you want to unlink the extra charges from this property?
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={() => setShowLinkUnlinkModel(false)}
                >
                    Cancel
                </SideCancelBtn>
                <DeleteBtn
                    onClick={handleDeleteSubmit}
                    disabled={linkPropertyLoading}
                    className="border border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white"
                >
                    {linkPropertyLoading ? "Processing..." : "Unlink"}
                </DeleteBtn>
            </div>
        </Model>
    );
};
const WarningText = tw.p`text-gray-500 text-base mb-4`;
export default UnlinkCharges;
